<template>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document" :style="isAllowedToEdit?'height:400px':'height:auto'">
            <div class="modal-content">
                <div class="modal-header p-2">
                    <h6 class="modal-title">{{isAllowedToEdit?$t('Edit'):$t('Add')}}</h6>
                    <button class="close text-white" data-dismiss="modal" aria-label="Close" @click="closeModal">
                        <span aria-hidden="true">
                            <cancel-icon class="close-icon" style="height: 30px !important;width: 30px !important;color: #fff;"></cancel-icon>
                        </span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="project-fields-wrapper">
                        <div class="comm-project-fields" :class="isAllowedToEdit?'edit-border-field':''">
                            <label class="input-field-label">{{$t('Key')}} *</label>
                            <template v-if="!isEditable('key_name') && Object.keys(dataToPopulate).length>0">
                                <span class="task-data-value"> {{dataToPopulate.key}}</span>
                                <edit-icon @click.native="editLinkTypeFields('key_name')" class="editIcon"></edit-icon>
                            </template>
                            <template v-if="isEditable('key_name')">
                                <div class="input-field-value-div">
                                   <input ref="linkName" v-model="keyName" :placeholder="$t('Enter key name')" type="text" autocomplete="off" tabindex="1" class="rounded text-light comm-input-field-style" :style="isAllowedToEdit?'width:85%':'width:100%'" style="float:inline-start;">
                                    <div v-if="isAllowedToEdit" class="d-flex" style="height: 40px;align-items: center;">
                                        <save-icon @click.native="FieldUpdateRequest('key_name')"></save-icon>
                                        <cancel-icon @click.native="cancelFieldsEdit('key')"></cancel-icon>
                                    </div>
                                </div>
                            </template>    
                        </div>
                        <div class="comm-project-fields" :class="isAllowedToEdit?'edit-border-field':''">
                            <label class="input-field-label">{{$t('Alias')}} *</label>
                            <template v-if="isAllowedToEdit">
                                <div style="display: flex;">
                                    <div class="col-md-12 rounded p-0" id="values" style="height: auto;">
                                        <ul class="p-0 m-0 active-tag lists-display-ul" :class="{applyBorderOnScroll:searchAliasList.length>5}">
                                            <li @click="editLinkTypeFields('alias_list');selectedValueId = ''" class='add-new-lists-styles'>
                                                <div style="margin-inline-end: 5px;position: relative;top: -2px;">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="25" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                                        <path d="M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z"/>
                                                    </svg>
                                                </div>
                                                <div style="font-size: 14px;">{{$t('Add values')}}</div>
                                            </li>
                                            <template v-for="op in searchAliasList">
                                            <li id="tag_field" v-if="op.value.trim().length > 0" class='view-lists'  :key="op.id" style="margin-inline-start: 10px !important;">
                                                <div class="w-100">
                                                <div class="d-inline-flex values-list">
                                                    <span v-show="!isEditting(op.id)">{{op.value}}</span>
                                                    <div class="show-on-hover ml-2">
                                                        <edit-icon @click.native="editValueNameField(op.id, op.value)" v-show="!isEditting(op.id)" class="edit-value-icon show-tags-delete"></edit-icon>
                                                        <div class="show-tags-delete ml-2" v-show="!isEditting(op.id)" 
                                                            @click="removeValueFromList(op.id)" >
                                                            <svg width="16" height="16" viewBox="0 0 16 16" class="bi bi-trash-fill" style="margin-inline-end: 8px" fill="#c5c0c0" xmlns="http://www.w3.org/2000/svg">
                                                                <path fill-rule="evenodd" d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7z"/>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>
                                                <input
                                                minlength="3"
                                                type="text"
                                                v-model="editedValue"
                                                v-show="isEditting(op.id)"
                                                :ref="op.id"
                                                :placeholder="$t('Enter alias')"
                                                class="rounded text-light comm-input-field-style align-input-field"
                                                style="padding-inline-start: 7.4px;width:85%"
                                                required
                                                />
                                                </div>
                                                <div v-show="isEditting(op.id)">
                                                <div class="d-flex" style="position: relative;
                                                bottom: 10px;">
                                                    <save-icon @click.native="updateSeletedValue(op.id)"></save-icon>
                                                    <cancel-icon @click.native="selectedValueId = '';refreshPage=false;"></cancel-icon>
                                                </div>
                                                </div>
                                            </li>
                                            </template>
                                        </ul>
                                    </div>
                                </div>
                                <!-- <span class="task-data-value"> {{dataToPopulate.outward_desc}}</span>
                                <edit-icon @click.native="editLinkTypeFields('alias_list')" class="editIcon"></edit-icon> -->
                            </template>
                            <template v-if="isEditable('alias_list')">
                                <div class="input-field-value-div" style="    display: flex;
                                align-items: center;">
                                    <div style="display: flex;
                                    flex-direction: column;
                                    margin-top: 10px;
                                    width: 100%;">
                                        <textarea ref="linkName" v-model="aliasList" :placeholder="$t('Enter alias')"  type="text" autocomplete="off" tabindex="1" class="rounded text-light comm-input-field-style" style="float:inline-start;max-height:200px;min-height:40px;width:100%"></textarea>
                                        <div class="config-desc mt-1">
                                            {{$t('You can add multiple aliases with comma(,) seperation')}}.
                                        </div>
                                    </div>
                                   <div v-if="isAllowedToEdit" class="d-flex" style="height: 40px;align-items: center;">
                                        <save-icon @click.native="saveNewAliasValues()"></save-icon>
                                        <cancel-icon @click.native="cancelFieldsEdit('alias_list')"></cancel-icon>
                                    </div>
                                </div>
                            </template>    
                        </div>
                    </div>  
                </div>
                <div class="modal-footer p-0 primary-btn-style"  style="height:55px">
                    <button class="btn btn-outline-secondary" data-dismiss="modal" @click="closeModal">{{$t('Cancel')}}</button>
                    <button v-if="!isAllowedToEdit" class="btn btn-outline-primary mr-2" @click='addNewSearchAliases()'>{{$t('Save')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>  

<script>
    import {mapActions} from "vuex";
    import Utils from "../../components.utils.js"   
    import EditIcon from "../core/InlineEditField.vue";
    import SaveIcon from "../core/InlineSaveField.vue";
    import CancelIcon from "../core/InlineCancelField.vue";

    export default {
        props:["dataToPopulate", "isAllowedToEdit"],
        data() {
            return{
                keyName:"",
                aliasList:"",
                editingKeyName:null,
                searchAliasList:[],
                selectedValueId: "",
                editedValue:"",
                mainFieldKeyName:"",
            }
        },

        components:{
            'cancel-icon':CancelIcon,
            "edit-icon":EditIcon,
            "save-icon":SaveIcon,
        },

        methods:{
            cancelSelectedValue(){
                this.editedValue = ""
                this.mainFieldKeyName = ''
                this.selectedValueId=""
            },
            setFocusToInputField(valueId){
                this.$nextTick(() => {
                    const editIconRef = this.$refs[valueId];
                    editIconRef[0].focus();
                });
            },
            editValueNameField(valueId, valueName) {
                this.cancelFieldsEdit('alias_list');
                this.mainFieldKeyName = ''
                this.editedValue = valueName;
                this.selectedValueId = valueId
                this.setFocusToInputField(valueId);
            },
            isEditting(valueId) {
                return valueId === this.selectedValueId;
            },
            isEditable(keyname){
                if(this.isAllowedToEdit){
                    return keyname === this.editingKeyName;
                }
                return true;
            },

            closeModal(){
                this.$emit("closeModal", true);
            },

            editLinkTypeFields(fieldName, fieldValue){
                console.log(fieldValue)
                this.editingKeyName = fieldName;
                if(fieldName == "key_name"){
                    this.keyName = this.dataToPopulate.key;
                }
                // if(fieldName == "alias_List"){
                //     this.searchAliasList = this.dataToPopulate.alias;
                // }
            }, 

            cancelFieldsEdit(fieldName){
                this.editingKeyName = null;
                if(fieldName == "key_name"){
                    this.keyName = this.dataToPopulate.key;
                }
                if(fieldName == "alias_List"){
                    this.searchAliasList = this.dataToPopulate.alias;
                }
            },
            getFilteredAliasWithId(){
                if(this.aliasList && this.aliasList.trim().length > 0){
                    let filteredList = [...new Set(this.aliasList.split(",").map(item => item.trim()))]
                                                    .map(value => ({
                                                        id: Utils.getUUID(),
                                                        value: value
                                                    }));
                    return filteredList;
                }else{
                    return []
                }
            },
            removeValueFromList(valueId){
                if(this.searchAliasList){
                    let indx = this.searchAliasList.findIndex(op=>op.id == valueId)
                    if(indx >= 0){
                        this.searchAliasList.splice(indx, 1);
                        this.FieldUpdateRequest('alias_list');
                    }
                }
            },
            updateSeletedValue(valueId){
                if(typeof this.editedValue == "undefined" || this.editedValue.trim().length <= 0){
                    alert("Empty value is not supported.\nPlease enter valid value.")
                    return;
                }

                let valIdx = this.searchAliasList.findIndex(op=>op.id==valueId)
                if(valIdx >= 0){
                    let valEntry = this.searchAliasList.find(op=>op.value == this.editedValue.trim())
                    if(valEntry){
                        alert("' " + this.editedValue.trim() + " ' value is already exists. Please add different value.")
                        return;
                    }
                    let valInfo = {
                        "id": valueId,
                        "value":this.editedValue.trim()
                    }
                    this.searchAliasList[valIdx] = valInfo
                }
                this.FieldUpdateRequest('alias_list')
                this.cancelSelectedValue()
            },
            saveNewAliasValues(){
                if(this.isAllowedToEdit){
                    this.searchAliasList = [...this.searchAliasList, ...this.getFilteredAliasWithId()];
                }else{
                    this.searchAliasList = this.getFilteredAliasWithId();
                }
                this.FieldUpdateRequest('alias_list')
            },
            addNewSearchAliases(){
                if(!this.keyName || (this.keyName.trim().length <= 0)){
                    alert("Empty Key Name.PLease add valid Key name.");
                    return false;
                }

                if(!this.aliasList || (this.aliasList.trim().length <= 0)){
                    alert("Empty alias. PLease add valid alias.");
                    return false;
                }
                let payload = {key: this.keyName.trim(), alias:this.getFilteredAliasWithId()};
                this.addNewSearchAlias(payload).then((data)=>{
                    if (Utils.isAcceptedStatusCode(data.statusCode)) {
                        if(data.message) this.$toast.success(data.message);
                        this.$emit("closeModal", true);
                    } else {
                        if(data.message) this.$toast.error(data.message);  
                    }
                });

            },
            FieldUpdateRequest(field){
                let payload={_id:this.dataToPopulate._id, params:{}};
                if(field == "key_name"){
                    if(!this.keyName || (this.keyName.trim().length <= 0)){
                        alert("Empty Key Name");
                        return false;
                    }
                    payload["key"] = this.keyName.trim();
                }
                if(field == "alias_list"){
                    payload["alias"] = this.searchAliasList;
                }

                this.updateSearchAlias(payload).then((data) => {
                    if (Utils.isAcceptedStatusCode(data.statusCode)){
                        if(data.message){
                            this.$toast.success(data.message);
                            // this.$emit("closeModal", true);
                            this.editingKeyName = null;
                            if(field == "key_name"){
                                this.dataToPopulate['key'] = data.modified_data['key'];
                            }
                            if(field == "alias_list"){
                                this.dataToPopulate['alias'] = data.modified_data['alias'];
                                this.searchAliasList = data.modified_data['alias'];
                            }
                            this.dataToPopulate["modified_datetime"] = data.modified_data["modified_datetime"];
                        }else{
                            this.$toast.success("Successfully Updated")
                        } 
                        this.aliasList = ""
                    } else {
                        if(data.message) this.$toast.error(data.message);
                    }
                });
            },
            ...mapActions("alias", ["addNewSearchAlias", "updateSearchAlias"]),
        },
        created(){
            if(this.isAllowedToEdit){
                this.searchAliasList = this.dataToPopulate.alias
            }
        }
    }        

</script>

<style lang="scss" scoped>
    $header-background: #1a1a1a; //header bar background color (eg. Top nav)
    // $border-color: 1px solid #1a1a1a;
    $secondary-border-color: 1px solid #3a3a3a;
    $searchBar-border-color: 1px solid #202020;
    $background: #121212; //background color
    $background-color-on-hover: #141414;
    $body-background-color: #0d0d0d !important;; //Application background color
    $text-color: #eee;
    $dull-text-color: #757575;
    // $secondary-text-color: #bbb;
    $table-row-border: none;
    $active-blue : #007bff;
    $modal-border:1px solid #202020;
    $modal-background: #0a0a0a;
    $header-color:#9e9e9e; //Color of the header's title or nav bar labels

    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $secondary-text-color: #9c9c9c;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #4a4a4a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $icon-hover:#2c3339;
    $input-field-border-color:1px solid #3a3a3a;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;

    .modal-dialog {
        max-width: 500px !important;
        width: 500px !important;
        // height: 60% !important;
        margin: 0;
        padding: 0;
    }
  
    .modal-content {
        height: auto !important;
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $secondary-border-color;
        .modal-body{
            background: $primary-background;
            height: auto;
            overflow: auto;
            padding: 1rem !important;
        }
    }

    .modal {
        text-align: center;
        padding: 0 !important;
        display: inline-flex;
        position: fixed;
        align-items: center;
        justify-content: center;
        
    }
    .modal:before {
        content: "";
        display: inline-block;
        height: 100vh;
        vertical-align: middle;
        margin-inline-end: -4px;
        position: fixed;
        width: 100vw;
        inset-inline-start: 0;
        top: 0;
        background: #00000094;
    }
    .modal-dialog {
        display: inline-block;
        text-align: start;
        vertical-align: middle;
    }

    .btn{
        font-size:14px !important;
        height:100%;
    }


    .border{
        border: $border-color !important;
    }

    .activeclass{
        color: $active-blue;
    }

    textarea:focus{
        outline: none;
        bottom: 0px;
        inset-inline-start: 0px;
        --saf-0: rgba(var(--sk_highlight,18,100,163),1);
        box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
        border-radius: 4px;
        border-color: transparent;
        -webkit-appearance: none;
    }

    .modal-header,.modal-footer{
        border-top: $secondary-border-color !important;
        border-bottom: $secondary-border-color !important;
        background: $secondary-background-color;
        height:45px;
        .modal-title{
            color:$text-color;
            padding: 2%;
            // height:45px;
            line-height: 4px;
        }
    }

    .modal-header .close {
        margin: 0px !important;
    }
    button.close {
        padding: 0;
        background-color: transparent;
        border: 0;
    }
    ul{
        list-style-type: none;
    }

    .close-icon:hover{
        background: $icon-hover;
        border-radius: 20px;
    }

    .comm-project-fields{
        width: 100%;
        // display: inline-flex;
        margin-bottom: 10px;
        display: inline-block;
        // width: 96%;
        justify-content: space-between;
        display: inline-block;
        padding: 9px;
        border-radius: 4px;
        background:$primary-background;
        border: $secondary-border-color !important;
        label{
            margin-bottom: 3px;
            width: 100%;
            text-align: start;
            padding-inline-end: 10px;
            color: $secondary-text-color;
        }
        .input-field-value-div{
            width: 100%;
            display: inline-block;
        }
    }

    .comm-checkbox-field{
        height:30px;
        display: inline-block;
        padding-inline-start:8%;
        .input-field-label{
            display: inline-flex;
            height:100%;
            align-items: center;
        }
    }

    .comm-input-field-style{
        background: $primary-background!important;
        float: inline-start;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        height: $input-field-height;
    }
    .comm-input-label{
        display:inline-block;
        width:100%;
        margin:20px 10px;
        width:80%;
    }

    .primary-btn-style{
        margin-top:1%;
        justify-content: flex-end;
        button{
            height: 35px;
            width: 70px;
        font-size:14px;
        }
    }

    .secondary-btn-style{
        color:$text-color;
    }
    .close-icon:hover{
        background: $icon-hover;
        border-radius: 20px;
    }


    ::-webkit-scrollbar {
      width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: $scrollbar-thumb-on-hover-background;
    }

.applyBorderOnScroll{
  border: $border-color;
  border-radius: 5px;
  overflow: auto;
  background:$primary-background;
}

.config-desc{
    color: $dull-text-color;
    font-size:12px;
  }
  

  .add-new-lists-styles{
    display: inline-flex;
    border-radius: 10px;
    margin: 0px 8px;
    justify-content: start;
    height: 27px;
    color:$add-button-text-color;
    padding: 4px 0px 0px 0px;
    svg{
      fill:$add-button-text-color !important;
    }
  }
  
  .add-new-lists-styles:hover{
    color:$add-button-text-color-hover;
    svg{
      fill:$add-button-text-color-hover !important;
    }
  }
  .show-on-hover{
    display:flex;
    visibility: hidden;
  }

  .values-list:hover{
    .show-on-hover{
        visibility: visible;
      }
  }
  .comm-project-fields:hover{
        .editIcon{
            visibility: visible;
            margin-inline-start: 8px;
        }
    }

    .editIcon{
        visibility: hidden;
    }

  .view-lists{
    margin-top:5px;
  }

</style>